<div class="video-info-description">
  <div
    class="video-info-description-html"
    [innerHTML]="getHTMLDescription()"
    (timestampClicked)="onTimestampClicked($event)"
    myTimestampRouteTransformer
  ></div>

  <button
    *ngIf="completeDescriptionShown === false && video.description?.length >= 250"
    (click)="showMoreDescription()" class="video-info-description-more button-unstyle"
  >
    <ng-container i18n>Show more</ng-container>
    <span *ngIf="descriptionLoading === false" class="chevron-down"></span>
    <my-loader size="sm" class="description-loading" [loading]="descriptionLoading"></my-loader>
  </button>

  <button
    *ngIf="completeDescriptionShown === true"
    (click)="showLessDescription()" class="video-info-description-more button-unstyle"
  >
    <ng-container i18n>Show less</ng-container>
    <span *ngIf="descriptionLoading === false" class="chevron-up"></span>
  </button>
</div>
